<template>
  <div class="bs-wrapper communication">
    <transition :name="transitionName">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Communication',

  mixins: [],

  components: {},

  props: {},

  data() {
    return {
      transitionName: '',
    };
  },

  computed: {},

  watch: {
    $route(to, from) {
      if (
        (to.path !== '/' && to.path !== '/' && to.path !== '/') ||
        (from.path !== '/' && from.path !== '/' && from.path !== '/')
      ) {
        if (to.meta.index > from.meta.index) {
          //设置动画名称
          this.transitionName = 'slide-left';
        } else if (to.meta.index < from.meta.index) {
          this.transitionName = 'slide-right';
        } else if (to.meta.index === 99) {
          this.transitionName = '';
        }
      } else {
        this.transitionName = '';
      }
    },
  },

  created() {},

  mounted() {},

  destroyed() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.communication {
  width: 100%;
  background: #f4f4f4;
  padding: 9px 10px;
  box-sizing: border-box;
}
.Router {
  position: relative;
}
.Router > * {
  position: absolute;
  width: 100%;
  text-align: center;
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 0.3s;
}

.slide-right-enter {
  opacity: 0;
  transform: translateX(-100%);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translateX(100%);
}

.slide-left-enter {
  opacity: 0;
  transform: translateX(100%);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translateX(-100%);
}
</style>
